import "../style/PageLanding.scss"
import { HamburgerMenu, Navbar } from "../components"
import { ChevronDownIcon } from "../svg"
import { Link } from "react-router-dom"
import { splitText } from "../utils"
// import { useEffect } from "react"

function PageLanding({ src, isVideo, title, description }) {
	const handleScrollButton = ev => {
		ev.preventDefault()

		window.scroll(0, window.innerHeight)
	}

	// useEffect(() => {
	// 	if (isVideo) {
	// 		const video = document.querySelector("video")
	// 		video.onloadeddata = () => {
	// 			video.play()
	// 		}
	// 	}
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [])

	return (
		<>
			<div className="pageLanding">
				<HamburgerMenu main />

				{isVideo ? (
					<video muted loop preload="metadata" autoPlay playsInline>
						<source src={src} />
					</video>
				) : src ? (
					<>
						<img src={src} alt="landing" />
						<div className="pageLanding__filter" />
					</>
				) : (
					<div className="pageLanding__filter" />
				)}

				<div className="pageLanding__details">
					<Link to="/">
						<img src="/main logo.png" loading="lazy" alt="video" />
					</Link>

					<div className="pageLanding__text">
						<h1>{splitText(title)}</h1>

						<div className="pageLanding__text__separator" />

						<p>{splitText(description)}</p>
					</div>

					<div style={{ height: 200, width: "26%" }} />

					<button
						onClick={handleScrollButton}
						style={{ top: window.innerHeight - 75 }}
					>
						<ChevronDownIcon />
					</button>
				</div>
			</div>
			<Navbar />
		</>
	)
}

export default PageLanding
